import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
// environment variable package
require("dotenv").config();
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "/api"
// axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
// axios.defaults.headers.common["Referrer"] = "https://localhost:8080/";
// axios.defaults.headers.common["Access-Control-Allow-Credentials"] = "true";
// axios.defaults.headers.common["Access-Control-Allow-Methods"] = "GET,HEAD,OPTIONS,POST,PUT";
// axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept, x-client-key, x-client-token, x-client-secret, Authorization";

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("access_token") || null,
    admin: localStorage.getItem("is_admin") || null
  },
  getters: {
    loggedIn(state) {
      console.log(state.token)
      return state.token != null;
    },
    isAdmin(state) {
      console.log(state.admin)
      return state.admin != null;
    }
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    retrieveAdmin(state) {
      state.admin = true;
    },
    destroyAdmin(state) {
      state.admin = null;
    },
  },
  actions: {
    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        // send an authentication request to the server
        console.log(credentials)
        axios
          .post(
            "/staff/login",
            {},
            {
              auth: {
                // username: credentials.username
                password: credentials.password,
              },
            }
          )
          .then((response) => {
            // if successful, store generated token locally
            const token = response.data.token;

            localStorage.setItem("access_token", token);
            localStorage.setItem("is_admin", true);
            context.commit("retrieveToken", token);
            context.commit("retrieveAdmin");
            resolve(response);
          })
          .catch((error) => {
            console.log(error.response.data);
            reject(error);
          });
      });
    },
    retrieveTokenExternal(context, credentials) {
      return new Promise((resolve, reject) => {
        // send an authentication request to the server
        console.log(credentials)
        axios
          .post(
            "/project/login",
            {},
            {
              auth: {
                username: credentials.username,
                password: credentials.password,
              },
            }
          )
          .then((response) => {
            // if successful, store generated token locally
            const token = response.data.token;

            localStorage.setItem("access_token", token);
            localStorage.removeItem("is_admin");
            context.commit("retrieveToken", token);
            context.commit("destroyAdmin");
            resolve(response);
          })
          .catch((error) => {
            console.log(error.response.data);
            reject(error);
          });
      });
    },
    validateToken(context) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;

      return new Promise((resolve, reject) => {
        axios
          .get("/validate")
          .then((response) => {
            resolve(response);
            console.log(response)
          })
          .catch((error) => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("is_admin");
            context.commit("destroyToken");
            context.commit("destroyAdmin");
            reject(error);
          });
      });
    },
    destroyToken(context) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;

      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          localStorage.removeItem("access_token");
          localStorage.removeItem("is_admin");
          context.commit("destroyToken");
          context.commit("destroyAdmin");
          axios
            .post("/logout")
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    },
    post(context, data) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;
      console.log("post...")
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .post(data.url, data.data)
            .then((response) => {
              // context.commit(data.url, response.data);
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    get(context, data) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .get(data.url, {})
            .then((response) => {
              // context.commit(data.url, response.data);
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    get_blob(context, data) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .get(data.url, {responseType: "blob"})
            .then((response) => {
              // context.commit(data.url, response.data);
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    async post_blob(context, data) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;
      if (context.getters.loggedIn) {
        const fd = new FormData();
        fd.append('file', data.data, data.data.name);

        return await new Promise((resolve, reject) => {
          axios
            .post(
              data.url, 
              fd,  
              {headers: {'Content-Type': 'multipart/form-data'}},
              {responseType: "blob"}
            )
            .then((response) => {
              // context.commit(data.url, response.data);
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    delete(context, data) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .delete(data.url, data.data)
            .then((response) => {
              // context.commit(data.url, response.data);
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
    sendFeedback(context, data) {
      axios.defaults.headers.common["x-access-token"] = context.state.token;

      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .post("/feedback", {
              data: data.data
            })
            .then((response) => {
              context.commit("sendFeedback", response.data);
              resolve(response);
            })
            .catch((error) => {
              console.log(error);
              reject(error);
            });
        });
      }
    },
  },
  modules: {},
});
